import { useLocation as useLocationOrigin } from '../../router';

export const useLocation = (): { pathname: string; search: string } => {
  const location = useLocationOrigin();
  return {
    pathname: location.pathname,
    search: location.search,
  };
};
